import { useEffect, useRef } from "react";

export const useOnChange = <T>(value: T, callback: (value: T) => void) => {
  const ref = useRef<T | undefined>(undefined);

  useEffect(() => {
    if (ref.current === value) return;
    ref.current = value;
    callback(value);
  }, [value, callback]);
};
